import { render, staticRenderFns } from "./DrugHistory.vue?vue&type=template&id=5b2b6401&scoped=true"
import script from "./DrugHistory.vue?vue&type=script&lang=js"
export * from "./DrugHistory.vue?vue&type=script&lang=js"
import style0 from "./DrugHistory.vue?vue&type=style&index=0&id=5b2b6401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b6401",
  null
  
)

export default component.exports